import { Injectable } from "@angular/core";
import { EntityStoreService } from "../../../../shared/store/entity-store/entity-store.service";
import {
  EntityMetadata,
  EntityStoreState,
} from "../../../../shared/store/store-types.model";
import { FactureFacadeService } from "./facture-facade.service";
import { Facture } from "../../models/facture.model";

@Injectable({ providedIn: "root" })
export class FactureStoreService extends EntityStoreService<
  Facture,
  EntityMetadata,
  FactureState
> {
  constructor() {
    super({
      ...EntityStoreService.initialState,
      selectedFactureId: null,
      selectedBlId: null,
    });
  }
}

export interface FactureState extends EntityStoreState<FactureFacadeService> {
  selectedFactureId: string | null;
  selectedBlId: string | null;
}
